module.exports = __webpack_public_path__ + "img/myntra.1ca066cf.svg";